import { Injectable } from '@angular/core';
import { ConfigurationResourceService } from "libraries/service/resources/configuration/configurationResource.service";
import { EGraphClass, EGraphType, IDashboardConfig } from "libraries/interfaces/i-dashboard-config";
import { Observable } from "rxjs";

const configDefault: IDashboardConfig[] = [
    {
        name: "Ticketing Report",
        index: "*ticketing_report",
        filters: {
            requestFile: "get_agency_vendor.json",
            formFields : [],
        },
        criteria: {
            formFields : [],
        },
        data: [
            [
                {
                    type: EGraphType.NUMBER,
                    title: "Chiffres relatifs aux billets",
                    req: "Sales_Report_Ticket_Counts.json",
                    xaxis: "Nombre total",
                    yaxis: "Montant total",
                    "class": EGraphClass.SIZES
                },
                {
                    type: EGraphType.NUMBER,
                    title: "Chiffres relatifs aux EMDs",
                    req: "Sales_Report_EMD_Counts.json",
                    xaxis: "Nombre total",
                    yaxis: "Montant total",
                    "class": EGraphClass.SIZES
                }
            ],
            [
                {
                    type: EGraphType.LINE,
                    title: "Nombre d'évènements par semaine sur les billets",
                    req: "Nombre_d_evenements_par_semaine_sur_les_billets.json",
                    xaxis: "Semaines de la période de dates indiquée en critère",
                    displayX: true,
                    yaxis: "Nombre d'évènements par semaine",
                    displayY: true
                },
                {
                    type: EGraphType.LINE,
                    title: "Nombre d'évènements par semaine sur les EMDs",
                    req: "Nombre_d_evenements_par_semaine_sur_les_EMDs.json",
                    xaxis: "Semaines de la période de dates indiquée en critère",
                    displayX: true,
                    yaxis: "Nombre d'évènements par semaine",
                    displayY: true
                }
            ],
            [
                {
                    type: EGraphType.BAR,
                    title: "Valeur cumulée par semaine des billets émis",
                    req: "Valeur_cumulee_par_semaine_des_billets_emis.json",
                    xaxis: "Semaines de la période de dates indiquée en critère",
                    displayX: true,
                    yaxis: "Valeur cumulée des billets émis",
                    displayY: true
                },
                {
                    type: EGraphType.BAR,
                    title: "Nombe d'UPs cumulés par semaine",
                    req: "Nombe_d_UPs_cumules_par_semaine.json",
                    xaxis: "Semaines de la période de dates indiquée en critère",
                    displayX: true,
                    yaxis: "Nombe d'UPs cumulés par semaine",
                    displayY: true
                }
            ],
            [
                {
                    type: EGraphType.BAR,
                    title: "Sales Report AveragePrice",
                    req: "SalesReport_AveragePrice.json",
                    xaxis: "Jours de la période de dates indiquée en critère",
                    displayX: true,
                    yaxis: "Prix total moyen",
                    displayY: true
                }
            ],
            [
                {
                    type: EGraphType.BAR,
                    title: "Nombre d'UPs cumulées par compagnie aérienne",
                    req: "Nombre_d_UPs_cumulees_par_compagnie_aerienne.json",
                    xaxis: "Compagnies aériennes",
                    displayX: true,
                    yaxis: "Nombre d'UPs cumulées par compagnie aérienne",
                    displayY: true
                },
                {
                    type: EGraphType.ROTATEBAR,
                    title: "Nombre de billets émis par vendeur (titulaire du dossier)",
                    req: "Nombre_de_billets_emis_par_vendeur.json",
                    xaxis: "Nombre de billets émis",
                    displayX: true,
                    yaxis: "Nom du vendeur",
                    displayY: true,
                    "class": EGraphClass.SIZEL
                }
            ],
            [
                {
                    type: EGraphType.SUNBURST,
                    title: "Répartition des UPs par compagnie aérienne",
                    req: "Repartition_des_UPs_par_compagnie_aerienne.json"
                },
                {
                    type: EGraphType.SUNBURST,
                    title: "Répartition des montant de billets par compagnie aérienne",
                    req: "Repartition_des_UPs_par_compagnie_aerienne.json"
                },
                {
                    type: EGraphType.SUNBURST,
                    title: "Répartition du nombre de billets émis par compagnie aérienne",
                    req: "Repartition_des_UPs_par_compagnie_aerienne.json"
                }
            ]
        ]
    }
];

@Injectable()
export class DashboardDomainService {

    constructor(
        private readonly configurationResourceService: ConfigurationResourceService,
    ) {
    }

    public getConfiguration(): Observable<IDashboardConfig[]> {
        return this.configurationResourceService.get(['wui', 'app_dashboard', 'config', 'json', 'dashboard-config.json'], configDefault);
    }
}
